import {z} from 'zod';
import {UpdateDocumentRequest} from '../../api/generated/index.defs';
import {mapNullToUndefined} from '../../utils/zod';

export const documentSchema = z.object({
  jobId: z.number(),
  reviewId: mapNullToUndefined(z.number().optional()),
  codeId: mapNullToUndefined(z.number().optional()),
  name: mapNullToUndefined(z.string().optional()),
  url: z.string(),
}) satisfies z.Schema<UpdateDocumentRequest>;
export type DocumentSchema = z.TypeOf<typeof documentSchema>;
